import { $themeBreakpoints } from "@themeConfig";
import axios from "@axios";
import router from "@/router";
import { decrypt } from "@/utils/crypto";


export default {
  namespaced: true,

  state: {
    windowWidth: 0,
    shallShowOverlay: false,

    accessToken: localStorage.getItem("accessToken") || "",
    userMenuList: [],
    userMenuPermissions: [],
    settingSystem: localStorage.getItem("settingSystem") || "",
    userData: decrypt(localStorage.getItem("userData")),
  },

  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state;
      if (windowWidth >= $themeBreakpoints.xl) return "xl";
      if (windowWidth >= $themeBreakpoints.lg) return "lg";
      if (windowWidth >= $themeBreakpoints.md) return "md";
      if (windowWidth >= $themeBreakpoints.sm) return "sm";
      return "xs";
    },

    isLoggedIn: (state) => !!state.accessToken,

    userMenuList: (state) => {
      let data = state.userMenuList.length
        ? JSON.parse(state.userMenuList)
        : state.userMenuList;
      return data;
    },

    userMenuPermissions: (state) => {
      let data = state.userMenuPermissions.length
        ? JSON.parse(state.userMenuPermissions)
        : state.userMenuPermissions;
      return data;
    },

    settingSystem: (state) => {
      let data = state.settingSystem.length
        ? JSON.parse(state.settingSystem)
        : state.settingSystem;
      return data;
    },

    userData: (state) => {
      let data = state.userData.length
        ? JSON.parse(state.userData)
        : state.userData;
      return data;
    },

    isMenuPermissionLoaded: (state) => {
      return !!(state.userMenuPermissions && state.userMenuPermissions.length);
    },

    hasAccessMenuPermission: (state) => (name) => {
      if (name === "home") return true;

      let permissions = state.userMenuPermissions.length
        ? JSON.parse(state.userMenuPermissions)
        : state.userMenuPermissions;

      return permissions.includes(name);
    },
  },

  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },

    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay =
        val !== undefined ? val : !state.shallShowOverlay;
    },

    AUTH_SUCCESS(state, token) {
      state.accessToken = token;
    },

    SET_MENU_LIST(state, menus) {
      state.userMenuList = menus;
    },

    SET_MENU_PERMISSIONS(state, permissions) {
      state.userMenuPermissions = permissions;
    },

    SET_SETTING_SYSTEM(state, settingSystem) {
      state.settingSystem = settingSystem;
    },

    LOGOUT(state) {
      state.accessToken = "";
      state.userMenuList = "";
      state.userMenuPermissions = "";
      state.settingSystem = "";
    },
  },

  actions: {
    async fetchAllMenus({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          // 2️⃣ LOCAL MENU LIST (moved from backend)

          const menuResponse = [
            {
              url: "/admin-dashboard",
              title: "Services",
              route: "admin-dashboard",
              icon: "HomeIcon",
              permissions: [
                "admin-dashboard",
                "profile.details",
                "profile.change-password",
                "customer.customer-serviceinfo",
                "customer.payments",
                "customer.complains",
                "complain.create",
                "payment-history",
                "wallet.recharge",
                "wallet.transfer",
                "wallet.payment-status",
                "inventory",
              ],
            },
            {
              title: "Wallets",
              route: "Wallets",
              icon: "CreditCardIcon",
              children: [
                { title: "Recharge Wallet", route: "wallet.recharge" },
              ],
            },
            {
              url: "/wallet/transfer",
              title: "Wallet Transfer",
              route: "wallet.transfer",
              icon: "FileTextIcon",
            },
            {
              url: "/payment-history",
              title: "Wallet History",
              route: "payment-history",
              icon: "FileTextIcon",
            },
            {
              url: "/inventory",
              title: "Inventory",
              route: "inventory",
              icon: "FileTextIcon",
            },
            {
              url: "/customer/complains",
              title: "Complains",
              route: "customer.complains",
              icon: "AlertTriangleIcon",
            },
            {
              title: "My Profile",
              route: "My Profile",
              icon: "UserIcon",
              children: [
                { title: "Details", route: "profile.details" },
                { title: "Change Password", route: "profile.change-password" },
              ],
            },
          ];

          menuResponse.push({
            title: "Logout",
            icon: "LogOutIcon",
            isLogout: true,   // custom flag
            // no route
          });

          // 6️⃣ STORE RESULT

          commit("SET_MENU_LIST", JSON.stringify(menuResponse));

          commit(
            "SET_MENU_PERMISSIONS",
            JSON.stringify(menuResponse[0]?.permissions || []),
          );

          resolve(menuResponse);
        } catch (error) {
          commit("LOGOUT");

          delete axios.defaults.headers.common["Authorization"];

          router.push("/login").catch(() => { });

          reject(error);
        }
      });
    },
  },
};
